<template>
	<!-- Navbar for mobile devices -->

	<div
		:class="[
			'flex justify-end w-dvw bg-transparent height-[45px] z-100',
			isBurgerOpen ? 'fixed' : 'absolute'
		]"
	>
		<div
			:class="[
				'transition duration-(--default-transition-duration)',
				isBurgerOpen ? 'w-dvw h-dvh absolute bg-black opacity-20 z-2' : 'hidden bg-transparent z-[-1]'
			]"
			@click="toggleMenu"
		/>
		<button
			id="burger-button"
			class="hamburger hamburger--squeeze"
			type="button"
			@click="toggleMenu()"
		>
			<span class="hamburger-box">
				<span
					class="hamburger-inner transition-colors duration-(--default-transition-duration)"
					:class="isBurgerOpen ? 'bg-(--primary-brown) before:bg-(--primary-brown) after:bg-(--primary-brown)' : 'bg-(--primary-beige) before:bg-(--primary-beige) after:bg-(--primary-beige)'"
				/>
			</span>
		</button>
		<Transition name="slide-fade">
			<div
				v-if="isBurgerOpen"
				id="nav-menu-mobile"
				class="z-10 fixed top-0 right-0 grid place-items-start-center w-50 h-dvh border-x group bg-(--primary-beige)"
			>
				<nav class="flex flex-col justify-start items-center">
					<NuxtLink
						:to="ROUTES.base"
						class="flex w-full text-4xl font-serif! py-2 pl-6 transition duration-(--default-transition-duration) hover:scale-110"
						@click="toggleMenu"
					>
						B & G
					</NuxtLink>
					<NuxtLink
						:to="ROUTES.home"
						class="py-5 pl-7 w-full transition duration-(--default-transition-duration) text-lg hover:scale-110 hover:underline hover:underline-offset-[0.3rem]"
						:class="activeRoute === ROUTES.home ? 'underline underline-offset-[0.3rem]' : ''"
						@click="toggleMenu"
					>
						Home
					</NuxtLink>
					<NuxtLink
						:to="ROUTES.gallery"
						class="py-5 pl-7 w-full transition duration-(--default-transition-duration) text-lg hover:scale-110 hover:underline hover:underline-offset-[0.3rem]"
						:class="activeRoute === ROUTES.gallery ? 'underline underline-offset-[0.3rem]' : ''"
						@click="toggleMenu"
					>
						Gallery
					</NuxtLink>
					<NuxtLink
						:to="ROUTES.travel"
						class="py-5 pl-7 w-full transition duration-(--default-transition-duration) text-lg hover:scale-110 hover:underline hover:underline-offset-[0.3rem]"
						:class="activeRoute === ROUTES.travel ? 'underline underline-offset-[0.3rem]' : ''"
						@click="toggleMenu"
					>
						Travel
					</NuxtLink>
					<NuxtLink
						:to="ROUTES.dressCode"
						class="py-5 pl-7 w-full transition duration-(--default-transition-duration) text-lg hover:scale-110 hover:underline hover:underline-offset-[0.3rem]"
						:class="activeRoute === ROUTES.dressCode ? 'underline underline-offset-[0.3rem]' : ''"
						@click="toggleMenu"
					>
						Dress Code
					</NuxtLink>
					<NuxtLink
						:to="ROUTES.registry"
						class="py-5 pl-7 w-full transition duration-(--default-transition-duration) text-lg hover:scale-110 hover:underline hover:underline-offset-[0.3rem]"
						:class="activeRoute === ROUTES.registry ? 'underline underline-offset-[0.3rem]' : ''"
						@click="toggleMenu"
					>
						Registry
					</NuxtLink>
					<NuxtLink
						:to="ROUTES.weddingParty"
						class="py-5 pl-7 w-full transition duration-(--default-transition-duration) text-lg hover:scale-110 hover:underline hover:underline-offset-[0.3rem]"
						:class="activeRoute === ROUTES.weddingParty ? 'underline underline-offset-[0.3rem]' : ''"
						@click="toggleMenu"
					>
						Wedding Party
					</NuxtLink>
					<NuxtLink
						:to="ROUTES.qAndA"
						class="py-5 pl-7 w-full transition duration-(--default-transition-duration) text-lg hover:scale-110 hover:underline hover:underline-offset-[0.3rem]"
						:class="activeRoute === ROUTES.qAndA ? 'underline underline-offset-[0.3rem]' : ''"
						@click="toggleMenu"
					>
						Q & A
					</NuxtLink>
					<!--					<NuxtLink -->
					<!--						:to="ROUTES.rsvp" -->
					<!--						class="py-5 pl-7 w-full transition duration-(&#45;&#45;default-transition-duration) text-lg hover:scale-110 hover:underline hover:underline-offset-[0.3rem]" -->
					<!--						:class="activeRoute.includes(ROUTES.rsvp) ? 'underline underline-offset-[0.3rem]' : ''" -->
					<!--						@click="toggleMenu" -->
					<!--					> -->
					<!--						RSVP -->
					<!--					</NuxtLink> -->
				</nav>
			</div>
		</Transition>
	</div>
</template>

<script setup lang="ts">
	const { ROUTES } = globalStores();
	const { activeRoute } = utilityStores();
	const isBurgerOpen = ref<boolean>( false );

	const toggleMenu = () => {
		document.getElementById( "nav-menu-mobile" )?.classList.toggle( "open" );
		document.getElementById( "burger-button" )?.classList.toggle( "is-active" );
		isBurgerOpen.value = !isBurgerOpen.value;
	};
</script>

<style scoped>
	.hamburger {
		padding: 15px 15px;
		display: inline-block;
		cursor: pointer;
		transition-property: opacity, filter;
		transition-duration: 0.15s;
		transition-timing-function: linear;
		font: inherit;
		color: inherit;
		text-transform: none;
		background-color: transparent;
		border: 0;
		margin: 0;
		overflow: visible;
		z-index: 20;
	}

	.hamburger:hover {
		opacity: 0.7;
	}

	.hamburger.is-active:hover {
		opacity: 0.7;
	}

	.hamburger--squeeze .hamburger-inner {
		transition-duration: 0.1s;
		transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
	}

	.hamburger--squeeze .hamburger-inner::before {
		transition: top 0.075s 0.12s ease, opacity 0.075s ease; }
	.hamburger--squeeze .hamburger-inner::after {
		transition: bottom 0.075s 0.12s ease, transform 0.075s cubic-bezier(0.55, 0.055, 0.675, 0.19);
	}

	.hamburger--squeeze.is-active .hamburger-inner {
		transform: rotate(45deg);
		transition-delay: 0.12s;
		transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
	}

	.hamburger--squeeze.is-active .hamburger-inner::before {
		top: 0;
		opacity: 0;
		transition: top 0.075s ease, opacity 0.075s 0.12s ease;
	}

	.hamburger--squeeze.is-active .hamburger-inner::after {
		bottom: 0;
		transform: rotate(-90deg);
		transition: bottom 0.075s ease, transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);
	}

	.hamburger-box {
		width: 40px;
		height: 24px;
		display: inline-block;
		position: relative;
	}

	.hamburger-inner {
		display: block;
		top: 50%;
		margin-top: -2px;
	}

	.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
		width: 40px;
		height: 4px;

		border-radius: 4px;
		position: absolute;
		transition-property: transform;
		transition-duration: 0.15s;
		transition-timing-function: ease;
	}

	.hamburger-inner::before, .hamburger-inner::after {
		content: "";
		display: block;
	}

	.hamburger-inner::before {
		top: -10px;
	}

	.hamburger-inner::after {
		bottom: -10px;
	}

	.slide-fade-enter-active {
		transition: all 0.375s;
	}

	.slide-fade-leave-active {
		transition: all 0.375s;
	}

	.slide-fade-enter-from,
	.slide-fade-leave-to {
		z-index: -1;
		right: 0;
		transform: translateX(201px);
	}
</style>